<template>
  <div class="dati_warp">
    <div class="dati_bg">
      <div class="wrapper">
        <div class="top-section">
          <div class="title">
            <h4>请仔细阅读指导语</h4>
          </div>
          <div class="text_bewrite">
            <p v-for="(item,index) in datas[name][part].content" :key="index" v-html="item.text">
            </p>
          </div>
          <div class="icon_warp" v-if="datas[name][part].warning">
            <i class="icon_lingdang"></i><span v-html="datas[name][part].warning"></span>
          </div>
        </div>
        <div class="" v-if="part == 'znsp21'">
          <div v-for="(topic, index) in [0]" :key="index">
            <div class="img_list" >
              <div style="width:140px;">
                <img src="https://yumingtianxia.oss-cn-shanghai.aliyuncs.com/uploadFiles/v2/zrgx/zrgx_01.png" alt="">
                <div class="p">{{letterArr[0]}}</div>
              </div>
              <div style="width:140px;">
                <img src="https://yumingtianxia.oss-cn-shanghai.aliyuncs.com/uploadFiles/v2/zrgx/zrgx_02.png"alt="">
                <div class="p">{{letterArr[1]}}</div>
              </div>
              <div style="width:140px;">
                <img src="https://yumingtianxia.oss-cn-shanghai.aliyuncs.com/uploadFiles/v2/zrgx/zrgx_03.png" alt="">
                <div class="p">{{letterArr[2]}}</div>
              </div>
              <div style="width:140px;">
                <img src="https://yumingtianxia.oss-cn-shanghai.aliyuncs.com/uploadFiles/v2/zrgx/zrgx_04.png" alt="">
                <div class="p">{{letterArr[3]}}</div>
              </div>
            </div>
            <div class="radio-list" >
              <section class="light light2" style="display: flex;justify-content: space-between;">
                <div  v-for="(t, index) in topic.options" :key="index">
                  <label id="label2">
                    <span class="design design2"></span>
                  </label>
                </div>
              </section>
            </div>
          </div>
          <div class="text_bewrite" style="margin-top: 10px">
            <p> 每道题都是三个人或物的名称组合，请你判断三者之间的关系，并在四个选项中选择最符合、最能代表其关系的图形作为答案。</p>

            <div class="icon_warp" style="margin-top: 0px">
              <i class="icon_lingdang" style="position: relative;top:-25px"></i><span>作答示例：事物—“猫”、“狗”、“动物”；正确关系图—</span>
              <img  style="width: 80px" src="https://yumingtianxia.oss-cn-shanghai.aliyuncs.com/uploadFiles/v2/zrgx/zrgx_03.png" alt=""><span>。</span><br>
              <span>如果你明白当前的作答要求即可开始答题。限时8分钟。</span>
            </div>
          </div>
        </div>

        </div>
        <div class="imgs" v-if="part =='znsp41'">
          <ul >
            <li v-for="(img,index) in datas[name][part].imgs" :key="index">
              <img :src="img.src" alt="">
              <p>{{img.number}}</p>
            </li>
          </ul>
           <section class="light" style="position:relative;top:-30px;display: flex;justify-content: space-evenly;">
                <label v-for="(img,index) in datas[name][part].imgs" :key="index" style="height: 34px;width: 100px;position:relative;top:20px;justify-content: center;margin:0">
                  <input class="radio_btn" type="radio" name="light" v-model="radio" :value="index" disabled/>
                  <span class="design"></span>
                  <span class="text" style="margin-left:5px">{{img.text}}</span>
                </label>
          </section>
          <p style="position: relative;top:10px;font-size: 14px;color:red;padding-left: 56px">{{datas[name][part].answer}}</p>
        </div>
        <div class="table"  style="margin:0 auto" v-if="part =='xqqx11'" >
            <table id="customers">
              <tr>
                <th style="text-align: center">描述</th>
                <th style="text-align: center">完全符合</th>
                <th style="text-align: center">一般符合</th>
                <th style="text-align: center">完全不符合</th>
              </tr>
              <tr>
                <td >A. 通常我对事情的细节能记得很清楚 </td>
                <td>
                  <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light"
                        disabled
                        value="1"
                        checked
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
                <td >
                   <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light"
                        disabled
                        value="2"
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
                <td>
                   <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light"
                        disabled
                        value="3"
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
              </tr>
              <tr>
                <td>B. 与独处相比，我大多时候更愿意参加集体活动</td>
                 <td>
                  <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light2"
                        disabled
                        value="4"
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
                <td>
                   <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light2"
                        checked
                        disabled
                        value="5"
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
                <td>
                   <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light2"
                        disabled
                        value="6"
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
              </tr>
              <tr>
                <td>C. 我喜欢按照已有的确定流程办事</td>
                 <td>
                  <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light3"
                        disabled
                        value="7"
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
                <td>
                   <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light3"
                        disabled
                        value="8"
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
                <td>
                   <section class="light">
                    <label>
                      <input
                        class="radio_btn"
                        type="radio"
                        name="light3"
                        disabled
                        checked
                        value="9"
                      />
                      <span class="design"></span>
                      <span class="text"></span>
                    </label>
                  </section>
                </td>
              </tr>
            </table>
          </div>
        <div class="btn_warp" id="vue-audio">
          <button style='position: relative;top:-20px' v-if="datas[name][part].url3" @click="$router.push(datas[name][part].url3)">
             演示
          </button>
          <button style='position: relative;top:-20px' v-if="datas[name][part].url2" @click="datas[name][part].text?'':$router.push(datas[name][part].url2)">
            {{datas[name][part].text||'练习'}}
            <vue-audio :file="file1_1"  v-if="datas[name][part].text"/>
          </button>
          <button style="position: relative;top:-20px" @click="datas[name][part].bool?goNext(datas[name][part].item):$router.push(datas[name][part].url)">
             开始
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueAudio from "vue-audio";
export default {
  data() {
    return {
      name: this.$route.query.name,
      part: this.$route.query.part,
      file1_1: require("../../../../../public/mp3/ceshi.mp3"),
      radio:'2',
      datas:{
        rgtx:{ //人格特性
          rgtx11:{
            url:{path:'/careerevalution/rgtx/ques11',query:{name:''}},
            content:[
              {text:'1、答案没有正误之分，请根据你是怎样做的或最倾向于如何决定进行选择。'},
              {text:'2、测试的目的是反映最真实的自己。请最大程度放松下来，选择更接近你平时的感受或行为的选项。'},
            ]
          }
        },
        //智能水平
        znsp:{
          znsp11:{
            url:{path:'/careerevalution/znsp/ques11',query:{name:''}},
            content:[
              {text:'本测验任务是观察题目，选择A、B、C、D中你认为正确的选项完成作答。每次显示一道题目，选中选项后点击确定可以切换到下一题。'},
            ],
            warning:'要求：在保证正确率的情况下快速答题，限时12分钟。'
          },
            znsp12:{
            url:{path:'/careerevalution/znsp/ques12',query:{name:''}},
            content:[
              {text:'本测验任务是观察题目，选择A、B、C、D中你认为正确的选项完成作答。每次显示一道题目，选中选项后点击确定可以切换到下一题。'},
            ],
            warning:'要求：在保证正确率的情况下快速答题，限时8分钟。'
          },
          znsp21:{
            url:{path:'/careerevalution/znsp/ques21',query:{name:''}},
            content:[
              {text:'本测验有10道题，测验中事物之间的关系被分为四种，分别用不同的图形表示(如下所示)，并作为答案选项。'},
            ],
            // warning:'事物—“猫”、“狗”、“动物”；正确关系图—B。如果你明白当前的作答要求即可开始答题。限时8分钟。'
          },
          znsp22:{
            url:{path:'/careerevalution/znsp/ques22',query:{name:''}},
            content:[
              {text:'本测验有12道题，每组将呈现三到六个动物或植物。你需要根据自身对动植物的认识经验或动植物的种属知识，简单分析他们的类别情况（参照事物分类的门、纲、目或科的层级标准），然后从中选出与其他事物不属于同一类别的。'},
            ],
            warning:'作答示例：' +
                '在“猫、狗、狼”的组合中，猫属于猫科动物，狗和狼属于犬科动物，则应当选出猫。<br>在“家蚕、蝴蝶、美国白蛾、萤火虫”的组合中，萤火虫为鞘翅目，余者为鳞翅目，则应当选出萤火虫。<br>如果你明白当前的作答要求即可开始答题。限时10分钟。'
          },
          znsp31:{
            url:{path:'/careerevalution/znsp/ques31',query:{name:''}},
            content:[
              {text:'下面的题目将会给你呈现两幅图，左边是原图，右边是左边成一定比例的图形，请你看到后判断，左右两图的比例是多少？在四个选项中选择你认为正确的比例值。'},
            ],
            warning:'要求：在保证正确率的情况下快速答题。'
          },
          znsp32:{
            url:{path:'/careerevalution/znsp/ques32',query:{name:''}},
            content:[
              {text:'本测验的任务是观察题目，从给出的选项中选出你认为正确的选项完成作答。每次显示一道题目，选中选项后点击确定可以切换到下一题。'},
            ],
            warning:'要求：本测试时间限制为12分钟，请尽快作答。'
          },
          znsp33:{
            url:{path:'/careerevalution/znsp/ques33',query:{name:''}},
            content:[
              {text:'本测验中，每题会给你呈现一幅图，两个选项，这两个选项在色值上会有一些细微的差异，请你将两个选项中颜色与图中颜色完全相同的选出，用鼠标点击相应的选项。'},
            ],
            warning:'要求：在保证正确率的情况下快速答题。'
          },
          znsp41:{
            url:{path:'/careerevalution/znsp/ques41',query:{name:''}},
            content:[
              {text:'请观察题干给出的图片内容，根据要求从选项中选出最恰当的图片排序，点击任何一个选项都会切换到下一题。'},
            ],
            warning:'示例：以下三张图片次序上需要调整，请你将它们排成应有的次序并做出选择，以合理说明该故事。',
            imgs:[
              {src:'./imgs/careerEvaluation/page41_1.png',number:'A',text:'A→B→C'},
              {src:'./imgs/careerEvaluation/page41_2.png',number:'B',text:'C→A→B'},
              {src:'./imgs/careerEvaluation/page41_3.png',number:'C',text:'B→A→C'}
            ],
            answer:'正确答案是B→A→C，这三张图片讲述了一个鸟筑巢的故事。'

          },
          znsp42:{
            url:{path:'/careerevalution/znsp/ques42',query:{name:''}},
            content:[
              {text:'请观察左侧给出的图片，分析给定图片中包含或传达的信息，对事物或情境的发展、特征或关系进行分析，并选出最恰当的选项。'},
            ],
          },
          znsp43:{
            url:{path:'/careerevalution/znsp/ques43',query:{name:''}},
            content:[
              {text:'本测验有8题，任务是根据题目提示，设想当你遇到题中所描述的情况时会怎么应对，选择你认为最符合自己实际情况的一个选项，点击任何一个选项都会切换到下一题。'},
            ],
            warning:'请不要过多考虑，凭你的真实想法或情况选择即可。'
          },
          znsp51:{
            url:{path:'/careerevalution/znsp/ques51',query:{name:''}},
            content:[
              {text:'本测验中，每一题将会出现两个数学算式，请你口算并比较两个算式计算结果的大小，选择对应的符号选项。每次显示一道题，选中选项后点击确定可以切换到下一题。'},
            ],
            warning:'要求快速且准确。建议每道题的作答时间不要超过1.5分钟。'
          },
          znsp52:{
            url:{path:'/careerevalution/znsp/ques52',query:{name:''}},
            content:[
              {text:'本测验的任务是观察数列，推理出？号位置应填的数字。点击灰色区域输入数字，然后点击下一题即可提交本题答案并切换至下一题。'},
            ],
            warning:'要求：在保证正确率的情况下快速答题。建议每道题的作答时间不要超过3分钟。'
          },
          znsp53:{
            url:{path:'/careerevalution/znsp/ques53',query:{name:''}},
            content:[
              {text:'本测验任务是观察题目，选择你认为正确的选项完成作答。每次显示一道题目，选中选项后点击确定可以切换到下一题。'},
            ],
            warning:'要求：在保证正确率的情况下快速答题。'
          },
           znsp61:{
            url:{path:'/careerevalution/znsp/ques61',query:{name:''}},
            url2:{path:'/careerevalution/znsp/ques61',query:{name:'test'}},
            content:[
              {text:'本测验中，每次出现五个图形。第一个为标准图，后面四个中有两个图为标准图旋转一定角度后的结果，可以重合，其余两个无法重合。要求你选出可以重合的两个选项，答错或少答均不计分。'},
            ],
            warning:'要求：快速且准确。在正式做之前，先进行练习，然后点击开始，进行正式测试。',
            bool:true,
            item:61,
          },
          znsp71:{
            url:{path:'/careerevalution/znsp/ques71',query:{name:''}},
            url2:{path:'/careerevalution/znsp/ques71',query:{name:'test'}},
            content:[
              {text:'本测验有17题，任务是观察题干给出的面孔，判断其所表示的情绪类型，从喜悦、惊惧、悲伤、愤怒、平静5个选项中选出正确答案，点击任何一个选项都会切换到下一题。'},
            ],
            warning:'在正式做之前，先进行练习，每张图片最多呈现10s，请不要过多思考尽快作答。',
            bool:true,
            item:71
          },
          znsp81:{
            url:{path:'/careerevalution/znsp/ques81',query:{seq:'1'}},
            url2:{path:'/careerevalution/znsp/ques81',query:{type:'test'}},
            url3:{path:'/careerevalution/znsp/play',query:{name:'video'}},
            content:[
              {text:'本测验中将会出现两个运动方点和一个目标点。你需要通过鼠标点击上方的方向键分别控制两个方点的移动，尽可能靠近目标点。有两组箭头，位于中间的中心箭头表示控制的是相应的同色方点，其方向表示当前该色运动方点的运动方向。每组箭头中的左偏右偏两个箭头用来控制运动方点的方向，每点击一次，运动方点就依据当前运动方向偏10度，再继续运动。你需要对两个运动方点的运动状态进行估计并确定首先控制哪个方点，然后继续对两个运动方点进行权衡与控制，以使两个方点离目标点更近、更准。'},
            ],
            warning:'注意：每次操作持续时间为20s，20s 后运动方点将停止运动保持终点状态。在正式做之前，先看演示，并进行1次练习方可进行正式测试，共进行6次正式测试。',
            bool:true,
            item:81
          },
           znsp91:{
            url:{path:'/careerevalution/znsp/ques91',query:{name:''}},
            url2:{path:'/careerevalution/znsp/ques91',query:{name:'test'}},
            content:[
              {text:'本测试中，你的任务是通过操作运动点的运动方向走出迷宫。你需要使用键盘上的“D”和“K”键，来操作一端像蛇型的红色线条的前进方向，从迷宫的中心走到外沿的终点，在走的过程中，你要尽量做到不碰壁，不走入死路。'},
            ],
            warning:'在操作过程中如果碰触迷宫墙壁会出现提示，测试界面显示“碰壁次数”。在正式做之前，先进行练习，然后点击开始，进行正式测试。建议作答时间不要超过10分钟。',
            bool:true,
            item:91
          },
           znsp101:{
            url:{path:'/careerevalution/znsp/ques101',query:{name:''}},
             url2:{path:'/careerevalution/znsp/ques101',query:{name:'test'}},
            content:[
              {text:'本测验有10道题，在正式答题前先播放测试文件，保证电脑声音播放正常，并尽量戴耳机作答，避免干扰。正式作答时你需要阅读题目要求，然后听对应的音乐片段做出判断，然后选择你认为的正确答案。'},
            ],
            warning:'除第4题需全部听完外，其他题目如果音乐较长，听完部分音乐后即可做出判断，则可不必完全听完。每段音乐最多可听两次，总体限时12分钟。',
            bool:true,
            item:101,
            text:"试听"
          }
        },
        xqqx:{
          xqqx11:{
            url:{path:'/careerevalution/xqqx/ques11',query:{name:''}},
            content:[
              {text:"请阅读以下3句描述，判断这些描述与你自身情况的符合程度并进行排序：符合程度最高的描述选择‘完全符合'选项，符合程度次之的描述选择‘一般符合’，不符合或符合程度相对较低的描述选择‘完全不符合’。注意一句描述只能对应一个符合程度选项，且不同描述对应不同选项。"},
            ],
          //  warning:'除第4题需全部听完外，其他题目如果音乐较长，听完部分音乐后即可做出判断，则可不必完全听完。每段音乐最多可听两次，总体限时12分钟。'
          }
        },
        // 职业价值观
         zyjzg:{
          zyjzg11:{
            url:{path:'/careerevalution/zyjzg/ques11',query:{name:''}},
            content:[
              {text:'1、答案没有正误之分，请根据你是怎样做的或最倾向于如何决定进行选择。'},
              {text:'2、测试的目的是反映最真实的自己。请最大程度放松下来，选择更接近你平时的感受或行为的选项。'},
            ],
            //warning:'选出极端的答案时，请确定它完全符合你的实际情况。'
          }
        },
        //心里舒适性
        xlssx:{
          xlssx11:{
            url:{path:'/careerevalution/xlsyx/ques11',query:{name:''}},
            content:[
              {text:'1、以下题目中列出了有些人可能面对的情况或问题，请仔细阅读每一条，然后根据该句话与你自己的实际情况相符合的程度（最近一个星期或现在），选择一个适当的选项。'},
              {text:'2、该测验主要是了解你的情况和感受，与智力和学习能力无关，答案无好坏对错之分，请按照你平常所想如实回答。难以决定时，选与你接近或最初想到的答案，不要过分考虑。'},
            ],
          //  warning:'在保证正确率的情况下快速答题。'
          }
        },
      },
      topics:[],
      letterArr:["A","B","C","D","E","F","G","H","I"],
    }
    
  },
  components:{
    VueAudio
  },
  mounted(){
    $('.vue-sound-wrapper').css('display','inline')
    $('.vue-sound__player').css('display','inline')
    $('.icon-stop2').css('display','none')
    // if(this.$route.query.part=='znsp21'){
    //   this.getTopicApi();
    // }
  },
  methods:{
    goNext(item){
      if(item==61){
        if(!sessionStorage.getItem('kongTest61')){
          this.$message.error("至少练习一次");
          return false
        }else{
           this.$router.push({
          path:'/careerevalution/znsp/ques61',
          query:{
            name:''
          }
        })
        }
      }
      if(item==71){
           if(!sessionStorage.getItem('kongTest71')){
          this.$message.error("至少练习一次");
          return false
        }else{
           this.$router.push({
          path:'/careerevalution/znsp/ques71',
          query:{
            name:''
          }
        })
        }
      }
      if(item==81){
           if(!sessionStorage.getItem('kongTest81')){
          this.$message.error("至少练习一次");
          return false
        }else{

           this.$router.push({
          path:'/careerevalution/znsp/ques81',
          query:{
            seq:'1'
          }
        })
        }
      }
      if(item==91){
           if(!sessionStorage.getItem('kongTest91')){
          this.$message.error("至少练习一次");
          return false
        }else{
           this.$router.push({
          path:'/careerevalution/znsp/ques91',
          query:{
            name:''
          }
        })
        }
      }
      if(item==101){
        this.$router.push({
          path:'/careerevalution/znsp/ques101',
          query:{
            name:''
          }
        })
      }
    },
    getTopicApi(){
      this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.zrnlList1}`,{},{
        headers:{
          token:sessionStorage.getItem('token')
        }
      })
          .then((res) => {
            this.topics = res.data.data
          })
    },
  }
};
</script>

<style scoped>
.title {
  text-align: center;
}

 @font-face{
        font-family: 'oswald';
        src : url('../../../../../public/mp3/苹方黑体-中黑-简.ttf');
  }

.title h4 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.text_bewrite {
  margin: 30px 0 0px 0;
}
.text_bewrite p {
  font-size: 16px;
  color: #333333;
  line-height: 30px;
}
.icon_warp {
  margin-top: 15px;
}
.icon_warp span {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #f81818;
}
.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}
.imgs{
  padding: 30px 0 0 0;
  height: 300px;
}
.imgs p{
  font-size: 16px;
  font-weight: 600px;
}
.imgs ul{
  display: flex;
  height: 200px;
  justify-content: space-evenly;
}
.imgs ul li{
  width: 150px;
  height: 150px;
  margin-right: 15px;
}
.imgs ul li p{
  text-align: center;
  font-size: 16px;
  font-weight: 600px;
}
.imgs ul li img{
  width:100%;
  height: 100%;
}

.table{
  margin-top: 30px;
}
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  width: 100%;
  border-collapse: collapse;
}
#customers td,
#customers th {
  font-size: 1em;
  border: 1px solid #979797;
  padding: 3px 7px 2px 7px;
  color: #000;
  background-color: #f8f8f8;
}
#customers th {
  font-size: 1.1em;
  text-align: left;
  padding-top: 5px;
  padding-bottom: 4px;
  background-color: #f8f8f8;
  color: #000;
}

/* 单选按钮 */

.light {
  --primary: #29d3ec;
  --other: #29d3ec;
  display: flex;
  justify-content: center;

}

.dark {
  --primary: hsl(1, 100%, 68%);
  --other: hsl(0, 0%, 90%);
  background: hsl(0, 0%, 10%);
}

/* h1 */
h1 {
  color: var(--other);
  padding: 8px 4px;
  border-bottom: 2px solid var(--other);
}

/* label */
label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  margin: 12px 0;
  height: 20px;
  background: hsl(0, 0%, 98%);
  cursor: pointer;
  position: relative;
  /* padding: 0 15px; */
}

/* input */
.radio_btn {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* .design */
.design {
  width: 16px;
  height: 16px;
  border: 1px solid var(--other);
  border-radius: 100%;
  /* margin-right: 16px; */
  position: relative;
}

.design::before,
.design::after {
  content: "";
  display: block;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.design:before {
  background: var(--other);
  opacity: 0;
  transition: 0.3s;
}
.design::after {
  background: var(--primary);
  opacity: 0.4;
  transition: 0.6s;
}
/* .text */
.text {
  color: #333;
  /* font-weight: bold; */
}
/* checked state */
.radio_btn:checked + .design::before {
  opacity: 1;
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}
</style>
<style>
  #vue-audio .icon-play3:before{
    content: url('/imgs/careerEvaluation/play3.png') !important;
  }
  #vue-audio .icon-pause2:before{
    content: url('/imgs/careerEvaluation/play4.png') !important;
  }
</style>
<style lang="less" scoped>
  .img_list{
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
  }
  .img_list .p{
    text-align: center;
    line-height: 50px;
  }
  /* input */
  .radio_btn2 {
    opacity: 0;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: -1;
  }
  /* .design */
  .design2 {
    width: 16px;
    height: 16px;
    border: 1px solid var(--other);
    border-radius: 100%;
    position: relative;
    flex-shrink: 0;
    margin: 0 auto;
    top:-2px;
  }
  #label2 {
    /*background: hsl(0, 0%, 98%);*/
    cursor: pointer;
    position: relative;
    background: none;
    border-radius: 2px;
    margin: 0;
    width: 140px;
    text-align: center;
  }
  .light2{
    margin: 0 auto;
  }
</style>